module.exports = __webpack_public_path__ + "static/staff-melissa-d27147bf27d7d41bcdb4a83a31599da2.png";